<template>
  <v-footer v-if="showFooter" :style="footerStyles" class="w-100">
    <template v-for="(part, index) in footerParts" :key="index">
      <div
        v-if="part.type === 'text'"
        :style="part.styles"
      >
        {{ part.content }}
      </div>

      <a
        v-else-if="part.type === 'link'"
        :href="part.href"
        target="_blank"
        rel="noopener noreferrer"
        :style="part.styles"
      >
        {{ part.content }}
      </a>
    </template>
  </v-footer>
</template>

<script setup>
import { inject, computed } from 'vue';

const themeData = inject('themeData', {});

const showFooter = computed(() => !!themeData?.footer);
const footerStyles = computed(() => themeData?.footer?.styles || '');
const footerParts = computed(() => themeData?.footer?.parts || []);
</script>
